
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoApprovalDialog extends Serenity.EntityDialog<PoApprovalRow, any> {
        protected getFormKey() { return PoApprovalForm.formKey; }
        protected getIdProperty() { return PoApprovalRow.idProperty; }
        protected getLocalTextPrefix() { return PoApprovalRow.localTextPrefix; }
        protected getNameProperty() { return PoApprovalRow.nameProperty; }
        protected getService() { return PoApprovalService.baseUrl; }
        protected getDeletePermission() { return PoApprovalRow.deletePermission; }
        protected getInsertPermission() { return PoApprovalRow.insertPermission; }
        protected getUpdatePermission() { return PoApprovalRow.updatePermission; }

        protected form = new PoApprovalForm(this.idPrefix);

    }
}